import { ToggleButton } from '@mui/material';
import styled from 'styled-components';

export const StyledToggleButton = styled(ToggleButton)`
  && {
    justify-content: flex-start;
  }
`;
